import { render, staticRenderFns } from "./CommercialTenantsViewer.vue?vue&type=template&id=8b7537d4&scoped=true&"
import script from "./CommercialTenantsViewer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CommercialTenantsViewer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CommercialTenantsViewer.vue?vue&type=style&index=0&id=8b7537d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7537d4",
  null
  
)

export default component.exports